const account = state => state.account

export default {
  account,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/account/getters.js